class PanelCalculator extends HTMLElement {
  connectedCallback() {
    // Panels have a fixed width AND a fixed length and are mounted vertically:
    //   columns across the wall = ceil(wallWidth / panelWidth)
    //   whole panels stacked per column = ceil(wallHeight / panelLength)
    //   total = columns * panelsPerColumn
    // Rounding up PER COLUMN is deliberate: a column's offcut is never carried
    // over to start the next column. If the panel length is unknown we fall back
    // to 1 panel per column (the old width-only behaviour).
    // All maths below is in cm, but the metafields are free text and the WPC
    // panels list theirs in mm ("2800 mm", "2800 x 122 mm") — treated as cm
    // that made a 28m panel, so height never added a second row (ceil(h/2800)
    // = 1). If the source string mentions mm, convert. ponytail: one unit per
    // string; a mixed "280 cm x 122 mm" would mis-scale, none exist today.
    const dim = (str) => {
      const v = parseFloat((str || '').replace(',', '.')) || 0;
      return /mm/.test(str || '') ? v / 10 : v;
    };
    this.panelWidth = dim(this.dataset.panelWidth);
    this.panelLength = dim(this.dataset.panelLength);

    // Last-resort source for either dimension: parse the free-text "afmetingen"
    // metafield, e.g. "275 x 60 cm" -> [275, 60]. ponytail: assumes the panel's
    // LONGEST listed dimension is its mountable length and the shortest is its
    // width (true for these wall panels). If a product is ever wider than it is
    // long, wire custom.breedte / custom.lengte explicitly.
    if (this.panelWidth <= 0 || this.panelLength <= 0) {
      const src = this.dataset.panelAfmetingen || '';
      const nums = src.match(/\d+([.,]\d+)?/g);
      if (nums && nums.length) {
        const scale = /mm/.test(src) ? 0.1 : 1;
        const vals = nums.map((n) => parseFloat(n.replace(',', '.')) * scale);
        if (this.panelLength <= 0) this.panelLength = Math.max(...vals);
        if (this.panelWidth <= 0 && vals.length >= 2) this.panelWidth = Math.min(...vals);
      }
    }

    this.template = this.dataset.resultTemplate || '';
    this.widthInput = this.querySelector('[data-width]');
    this.heightInput = this.querySelector('[data-height]');
    this.areaOutput = this.querySelector('[data-area]');
    this.resultOutput = this.querySelector('[data-result]');

    if (!this.widthInput || !this.heightInput) return;

    this.update = this.update.bind(this);
    this.widthInput.addEventListener('input', this.update);
    this.heightInput.addEventListener('input', this.update);
    this.update();
  }

  update() {
    const width = parseFloat(this.widthInput.value) || 0;
    const height = parseFloat(this.heightInput.value) || 0;
    const area = (width / 100) * (height / 100);

    if (this.areaOutput) {
      this.areaOutput.textContent = area > 0 ? area.toFixed(2).replace('.', ',') : '0';
    }

    if (!this.resultOutput) return;

    if (this.panelWidth > 0 && width > 0) {
      const columns = Math.ceil(width / this.panelWidth);
      // Only stack once a height is entered and the panel length is known;
      // otherwise keep 1 panel per column (offcuts stay per-column, never reused).
      const perColumn = this.panelLength > 0 && height > 0 ? Math.ceil(height / this.panelLength) : 1;
      const panels = columns * perColumn;
      this.resultOutput.textContent = this.template.replace('{count}', panels);
      this.resultOutput.hidden = false;
    } else {
      this.resultOutput.hidden = true;
    }
  }
}

customElements.define('panel-calculator', PanelCalculator);
